module.exports = __webpack_public_path__ + "img/setting.fad005f3.svg";